import { MobileRouterPaths } from "../../mobileAppCore/mobileAppConstants";

export const PAGES_OPEN_MOBILE_APP_IS_INVISIBLE: string[] = [
    MobileRouterPaths.firstStart,
];
